<small class="debug"> {{me}} </small>
<div fxLayout="row" fxLayoutAlign="start start">
  @if (loginMode) {
    <div fxFlex="100%">
      <mat-form-field>
        <mat-label>{{'account.userNameOrEmail' | transloco}}</mat-label>
        <input inputrestriction="basic1" autocomplete="off" matInput spellcheck="false" type="text" name="m_user" [(ngModel)]="m_user" placeholder="" required autofocus>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{'account.password' | transloco}}</mat-label>
        <input inputrestriction="basic1" autocomplete="off" matInput type="password" [(ngModel)]="m_pass" name="m_pass" placeholder="" required>
      </mat-form-field>
    </div>
  }
  <div fxFlex="100%">
    <br/>
    <mat-form-field style="width: 200px">
      <mat-label>{{'account.newBusiness' | transloco}}</mat-label>
      <input inputrestriction="basic1" autocomplete="off" matInput type="text" name="m_businessName" [(ngModel)]="m_businessName" (keyup)="updateName()" placeholder="" required>
    </mat-form-field>
  </div>
  <div style="width: 150px;">
    <br/>
    <canvas width="140" height="140" [attr.data-jdenticon-value]="user?.businessName"></canvas>
  </div>
  @if (loginMode) {
    <a color="warn" class="pull-left" (click)="$event.preventDefault(); setViewMode(m_viewMod.LOGIN)" href="#">
      <mat-icon style="position: relative; top: 6px">chevron_left</mat-icon>
      {{'account.back' | transloco}}
    </a>
  }
</div>
<button type="submit" (click)="onChangeBusinessName()" class="sub" mat-stroked-button color="primary">
  {{'account.changeBusiness' | transloco}}
  <mat-icon style="font-size: 1.3em; position: absolute; right: 10px">vpn_key</mat-icon>
</button>
